module.exports = require("./dir");


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/replacing-file4/index.js
 ** module id = 8
 ** module chunks = 0
 **/